module.exports = __webpack_public_path__ + "4feeec3145e559f55b28660be22807fd.jpg";